import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { CarService } from '../../../services/car.service';
import { Meta, Title } from '@angular/platform-browser';
import {CarsModel} from '../../../model/car.model';

@Component({
  selector: 'app-car-details',
  templateUrl: './car-details.component.html',
  styleUrls: ['./car-details.component.css']
})
export class CarDetailsComponent implements OnInit {
  public car: any;
  public slider: string[];
  public loading = true;
  public url = this.router.url;
  slideDetailsConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    infinite: true,
    autoplay: false,
    asNavFor: '.slideNav',
    fade: true
  };
  slideDetailsThumpConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    autoplay: false,
    asNavFor: '.slideTop',
    fade: false,
    focusOnSelect: true
  };


  constructor(
    public carService: CarService,
    private routeParams: ActivatedRoute,
    public carModel: CarsModel,
    private router: Router,
    private location: Location,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    this.routeParams.paramMap.subscribe(params => {
      this.carModel.make = params.get('make');
      this.carModel.series = params.get('series');
      this.carModel.stock_id = params.get('stock_id');
      // this.carModel.stock_id = params.get('stockId');
      // this.carModel.company_id = params.get('companyId');
      this.carService.getCar(this.carModel).subscribe(http => {
        this.car = http;
        this.loading = false;
        this.slider = [];
        this.fixHttpImages(this.car[0]);
        this.fixAbbreviation();
      });
    });
  }

  private fixAbbreviation() {
    if (this.car[0].fuel_type === 'D') {
      this.car[0].fuel_type = 'Diesel';
    }
    if (this.car[0].fuel_type === 'P') {
      this.car[0].fuel_type = 'Petrol';
    }
    if (this.car[0].fuel_type === 'E') {
      this.car[0].fuel_type = 'Electric';
    }
    if (this.car[0].transmission === 'A') {
      this.car[0].transmission = 'Automatic';
    }
    if (this.car[0].transmission === 'M') {
      this.car[0].transmission = 'Manual';
    }
  }

  private fixHttpImages(car) {
    for (const prop in car) {
      if (prop.startsWith('url')) {
        this.slider.push(car[prop].replace(/^http:\/\//i, 'https://'));
      }
    }
  }

  backToPage() {
    this.location.back();
  }

  private setMetaData() {
    this.title.setTitle('SA Motor Corporation' + ' | ' + this.car[0].make + ', ' + this.car[0].series);
    this.meta.addTags([
      {name: 'title', content: 'SA Motor Corporation' + ' | ' + this.car[0].make + ', ' + this.car[0].series},
      {name: 'description', content: 'SA Motor Corporation' + ' | ' + this.car[0].description},
      {name: 'theme-color', content: '#ffffff'},
      {name: 'creative_description', content: 'SA Motor Corporation' + ' | ' + this.car[0].description},
      {name: 'keywords', content: 'affordable, used, pre owned, vehicles, cars for sale, vehicle trader, ' +
          'AUDI, ABARTH, ALFA ROMEO, BAIC, CITROEN, FORD, HYUNDAI, JAC MOTORS, JEEP, KIA, LAND ROVER, MAZDA, MERCEDES-BENZ, NISSAN, ' +
          'PEUGEOT, RENAULT, SUBARU, SUZUKI, TATA, TOYOTA, VOLKSWAGEN, easy financing, balloon payment'},
      {name: 'author', content: 'VMG Software'},

      {property: 'og:title', content: 'SA Motor Corporation' + ' | ' + this.car[0].make + ', ' + this.car[0].series},
      {property: 'og:description', content: 'SA Motor Corporation' + ' | ' + this.car[0].description},
      {property: 'og:url', content: 'https://samotorcorporation.co.za/' + this.url},
      {property: 'og:type', content: 'website'},
      {property: 'og:site_name', content: 'SA Motor Corporation ' + this.car[0].make + ' ' + this.car[0].series},
      {property: 'og:image', content: this.car[0].url1},
      {property: 'og:image:url', content: this.car[0].url1},
      {property: 'og:image:width', content: '300'},
      {property: 'og:image:height', content: '300'},
      {property: 'og:image:alt', content: 'SA Motor Corporation ' + this.car[0].make + ', ' + this.car[0].series},
      {property: 'og:country-name', content: 'South Africa'},
      {property: 'fb:app_id', content: 'page-metadata-facebook-id'},
      {property: 'og:street-address', content: '11 Republic Road, Bordeaux, Randburg, 2194'},
      {property: 'og:email', content: 'ilan@samotorcorp.co.za'},
      {property: 'og:phone_number', content: '+27 (11) 326 1954 '},
      {property: 'og:locale', content: 'en_ZA'},

      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:title', content: 'SA Motor Corporation ' + ' | ' + this.car[0].make + ', ' + this.car[0].series},
      {name: 'twitter:description', content: 'SA Motor Corporation ' + ' | ' + this.car[0].description},
      {name: 'twitter:image', content: this.car[0].url1},
      {name: 'twitter:image:url', content: this.car[0].url1},
      {name: 'twitter:domain', content: 'samotorcorporation.co.za'},
    ]);
  }
}
